<template>
    <div class="grid place-items-center gap-4">
        <DsIcon
            class="text-content-primary"
            icon="fa-regular fa-circle-exclamation"
            size="lg"
        />
        <div class="grid place-items-center gap-3 text-center">
            <div class="grid gap-1">
                <p class="text-base font-medium text-content-primary">Something went wrong</p>
                <p class="text-content-md text-content-secondary">
                    We ran into an unexpected error while trying to load the page, please try again. If the problem continues,
                    contact us at
                    <a
                        class="underline"
                        href="mailto:support@closinglock.com"
                        target="_blank"
                    >
                        support@closinglock.com</a
                    >.
                </p>
            </div>
            <DsButton
                class="w-fit"
                size="sm"
                variant="tertiary"
                @click="$emit('retry')"
            >
                Try again
            </DsButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsButton from '@/components/design-system/form/input/DsButton.vue';

defineEmits<{
    retry: [];
}>();
</script>
